var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidateTrackingFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.5H18C19.3881 2.5 20.4999 3.61035 20.5 4.96973V15.8799C20.5 17.2394 19.3882 18.3496 18 18.3496H17.25C16.332 18.3496 15.4345 18.7092 14.7783 19.3643L13.0684 21.0537C12.4831 21.6315 11.5257 21.6315 10.9404 21.0537L9.23145 19.3643C8.57594 18.7099 7.68857 18.3496 6.75977 18.3496H6C4.61177 18.3496 3.5 17.2394 3.5 15.8799V4.96973C3.50015 3.61035 4.61186 2.5 6 2.5ZM12 11.2998C10.4523 11.2998 9.04788 11.9529 8.23047 12.9971L8.0752 13.2109C7.40622 14.207 8.10282 15.5596 9.32031 15.5596H14.6797C15.8827 15.5596 16.5963 14.2107 15.9248 13.2109L15.7695 12.9971C14.9521 11.9529 13.5477 11.2998 12 11.2998ZM12 5.25C10.4339 5.25 9.16992 6.51394 9.16992 8.08008C9.16996 9.63479 10.4325 10.9102 12 10.9102C13.5661 10.9102 14.83 9.64618 14.8301 8.08008C14.8301 6.51394 13.5661 5.25 12 5.25Z",
    fill: "#0747A6",
    stroke: "#0747A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateTrackingFilled);
export default __webpack_public_path__ + "static/media/candidateTrackingFilled.5f077ae65bab9909b8e3360db9652230.svg";
export { ForwardRef as ReactComponent };